import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getProductsObject } from "utils/common";
import { getCutSheetsService } from "services/siteRepo.service";
import PdfDocument from "components/siteRepo/common/pdfDocument";
import Modal from "common/modal";
import Button from "react-bootstrap/Button";
import { BlobProvider } from "@react-pdf/renderer";

const GenerateSitePdfModal = ({ floors = [], onClose }) => {
  const [showSiteInfo, setShowSiteInfo] = useState(true);
  const [showProductView, setShowProductView] = useState(true);
  const [showRoomView, setShowRoomView] = useState(true);
  const [showFloorPlanPictures, setShowFloorPlanPictures] = useState(true);
  const [showCutSheetImages, setShowCutSheetImages] = useState(true);
  const [pdfProductData, setPdfProductData] = useState();
  const [showPreview, setShowPreview] = useState(false);

  const { viewSite } = useSelector((state) => state.siteRepo);

  const handlePreviewPdf = () => {
    const productsObject = {};
    const response = floors.map(async (floors) => {
      const floorsResponse = await Promise.allSettled(
        floors?.layerInfoList?.map(async (layer) => {
          const { rooms } = layer;
          let productsObj = {};
          let totalProducts = 0;
          const { productsObjUpdated } = getProductsObject(productsObj, totalProducts, rooms, floors.name, layer.name);
          productsObjUpdated.cutSheetData = [];
          productsObject[`${floors.mprojectId}-${layer.layerId}`] = productsObjUpdated;
          return (await getCutSheetsService(floors.projectId)).map((item) => ({
            ...item,
            mprojectId: floors.mprojectId,
            projectName: floors.name,
            layerName: layer.name,
            layerId: layer.layerId,
          }));
        }),
      );

      return { floorsResponse };
    });

    Promise.all(response).then((re) => {
      re?.map((item) => {
        item?.floorsResponse?.map((floorItem) => {
          floorItem?.value?.map((layerItem) => {
            if (layerItem.cutSheetImage?.length) {
              productsObject[`${layerItem.mprojectId}-${layerItem.layerId}`].cutSheetData.push(layerItem);
            }
          });
        });
      });
      setPdfProductData(productsObject);
      setShowPreview(true);
    });
  };

  return (
    <Modal title="Generate PDF" handleCancel={onClose} size="lg" sectionName="" closeButtonText="Cancel">
      <div className="container-fluid p-2 border-0 m-0 generate-pdf">
        <div className="search-form-container__fields">
          <form className="search-form-container__fields__form">
            <div className="row border-0 p-0 m-0">
              <p className="info-note">Select the sections that needs to be included in the PDF.</p>
            </div>
            <div className="options-container">
              <div className="row align-items-center">
                <div className="col-12 col-sm-12 col-md-6 col-lg-5 my-0 search-form-container__fields__form-group switch-container">
                  <div className="switch-toggle d-flex align-items-center">
                    <div className="form-check form-switch d-flex align-items-center p-0 mx-md-4 my-md-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isShowSiteInfo"
                        checked={showSiteInfo}
                        onChange={() => setShowSiteInfo(!showSiteInfo)}
                      />
                      <span>Site Information</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-5 my-0 search-form-container__fields__form-group switch-container">
                  <div className="switch-toggle d-flex align-items-center">
                    <div className="form-check form-switch d-flex align-items-center p-0 mx-md-4 my-md-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isShowProductView"
                        checked={showProductView}
                        onChange={() => setShowProductView(!showProductView)}
                      />
                      <span>Product View</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-12 col-sm-12 col-md-6 col-lg-5 my-0 search-form-container__fields__form-group switch-container">
                  <div className="switch-toggle d-flex align-items-center">
                    <div className="form-check form-switch d-flex align-items-center p-0 mx-md-4 my-md-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isShowRoomView"
                        checked={showRoomView}
                        onChange={() => setShowRoomView(!showRoomView)}
                      />
                      <span>Room View</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-5 my-0 search-form-container__fields__form-group switch-container">
                  <div className="switch-toggle d-flex align-items-center">
                    <div className="form-check form-switch d-flex align-items-center p-0 mx-md-4 my-md-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isShowFloorPlanPictures"
                        checked={showFloorPlanPictures}
                        onChange={() => setShowFloorPlanPictures(!showFloorPlanPictures)}
                      />
                      <span>Floor Plan Pictures</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-12 col-sm-12 col-md-6 col-lg-5 my-0 search-form-container__fields__form-group switch-container">
                  <div className="switch-toggle d-flex align-items-center">
                    <div className="form-check form-switch d-flex align-items-center p-0 mx-md-4 my-md-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isShowCutSheetImages"
                        checked={showCutSheetImages}
                        onChange={() => setShowCutSheetImages(!showCutSheetImages)}
                      />
                      <span>Cut Sheet Pictures</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid search-form-container footer-actions mb-5 mt-4 py-4 d-flex flex-column flex-md-row justify-content-end border-0 px-0">
              <Button
                className="me-0"
                variant="primary"
                onClick={handlePreviewPdf}
                disabled={
                  !showSiteInfo && !showRoomView && !showProductView && !showFloorPlanPictures && !showCutSheetImages
                }
              >
                Print
              </Button>
            </div>
          </form>
        </div>
      </div>
      {showPreview && (
        <div className="container-fluid m-0 d-none">
          <BlobProvider
            document={
              <PdfDocument
                siteName={viewSite.siteName}
                siteData={viewSite}
                floors={floors}
                options={{ showSiteInfo, showProductView, showRoomView, showFloorPlanPictures, showCutSheetImages }}
                productsData={pdfProductData}
              />
            }
          >
            {({ blob, url, loading, error }) => {
              if (!loading && url && blob) {
                window.open(url);
                setShowPreview(false);
              }
            }}
          </BlobProvider>
        </div>
      )}
    </Modal>
  );
};

export default GenerateSitePdfModal;
